import { stringify } from 'qs';

import { DEFAULT_LOCALE } from 'constants/locale';
import { Config } from 'models/config';

interface CheckoutOptions {
  landingUrl?: string;
  lang?: string;
  name: string;
}

export class Checkout {
  checkoutUrl: string;

  constructor(checkoutUrl: string) {
    this.checkoutUrl = checkoutUrl;
  }

  generateUrl(referenceNumber: string, options: CheckoutOptions) {
    const query = { ...options };
    if (!query.lang) {
      query.lang = DEFAULT_LOCALE;
    }

    return this.checkoutUrl + '/' + referenceNumber + '?' + stringify(query);
  }

  open(referenceNumber: string, options: CheckoutOptions) {
    window.location.href = this.generateUrl(referenceNumber, options);
  }
}

let checkout = new Checkout('');

export function configureCheckout(config: Config) {
  checkout = new Checkout(config.checkoutUrl);
}

export { checkout };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/checkout.ts